import classes from './EntityHeader.module.css'

export const EntityHeader = ({ titlePart1, titlePart2, icon, iconText, secondaryIcon, secondaryText, setNavigate }) => (
    <div className={classes.headerBlock}>
        <h2 className={classes.headerTitle}>
            {titlePart1 && titlePart2 ? (
                <>
                    <span className={classes.titlePart1}>{titlePart1}</span>
                    {titlePart1 && titlePart2 && <span className={classes.titleSeparator}> at </span>}
                    <span 
                        className={classes.titlePart2}
                        onClick={() => setNavigate(true)}
                    >
                        {titlePart2}
                    </span>
                </>
            ) : titlePart1}
        </h2>
        <div className={classes.headerRow}>
            {iconText && (
                <div className={classes.headerRowItem}>
                    {icon && <img className={classes.icon} src={icon} />}
                    <p 
                    className={classes.headerText}
                    >
                        {iconText}
                    </p>
                </div>
            )}
            {iconText && secondaryText && <p className={classes.headerSeparator}>|</p>}
            {secondaryText && (
                <div className={classes.headerRowItem}>
                    {secondaryIcon && <img className={classes.icon} src={secondaryIcon} />}
                    <p className={classes.headerText2}>{secondaryText}</p>
                </div>
            )}
        </div>
    </div>
)
